import { httpClient } from "./RestService";

export const invite = async (recipient) => {
  return await httpClient().post("/v1/education/invitation", recipient, {
    headers: {
      "Content-Type": "text/plain", // application/json will put double quote around
    },
  });
};

export const getAll = async () => {
  return await httpClient().get("/v1/education/invitation");
};
